import { render } from "./Metadata.vue?vue&type=template&id=d2999b7c&scoped=true"
import script from "./Metadata.vue?vue&type=script&lang=js"
export * from "./Metadata.vue?vue&type=script&lang=js"

import "./Metadata.vue?vue&type=style&index=0&id=d2999b7c&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2999b7c"]])

export default __exports__